<template>
  <div class="row msearch2" id="mse2_mfilter" style="position: relative;">
    <div class="row preload" v-if="loading" style="margin-top: 4rem;">
      <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="col-md-3" style="margin-top: 130px; min-height: 150px;">
      <div class="side categories"></div>
      <form action="" method="post" id="mse2_filters">
        <div class="d-flex" style="margin-bottom: 2rem;">
          <button type="reset" class="btn btn-outline" style="margin-right:5px;" @click="clear">Сбросить</button>
          <button type="button" class="btn btn-outline-inverse" @click="filterHandler">Показать</button>
        </div>
        <div>
          <fieldset v-if="maxPrice">
            <h4 class="filter_title" style="margin-bottom: 6px;">Цена</h4>
            <vue-slider v-model="price"
                        min="0"
                        :max="maxPrice"
                        :enableCross="false"
                        style="margin-bottom: 1rem;"
            ></vue-slider>
            <div class="mse2_number_inputs_dis row">
              <div class="col-md-6">
                <label for="price_0" class="d-flex align-items-center">
                  От
                  <input type="number" name="price_0" id="price_0" class="form-control ml-1" v-model="price[0]" @input="numberValidator"/>
                </label>
              </div>
              <div class="col-md-6">
                <label for="price_1" class="d-flex align-items-center">До
                  <input type="number" name="price_1" id="price_1"   class="form-control ml-1" :max="maxPrice" v-model="price[1]" @input="numberValidator"/>
                </label>
              </div>
            </div>
          </fieldset>
          <fieldset id="mse2_resource|parent" v-if="prepareCategories().length">
            <h4 class="filter_title">Категория</h4>
            <div style="max-height: 250px; overflow-y:auto;">
              <template v-for="(cat, i) in prepareCategories()">
                <label :for="cat.code" class="" :key="i" style="display: block;" v-if="getCountCategory(cat.code)">
                  <input type="checkbox" name="resource|parent" :id="cat.code" :value="cat.code" v-model="categories" @input="checkCategory"/>
                  <span><strong>{{cat.title}}</strong></span>&nbsp;<sup>{{getCountCategory(cat.code)}}</sup>
                  <template v-for="(item, k) in cat.items">
                    <label :for="item.code" class="" :key="k" style="display: block; margin: 10px 1rem;" v-if="getCountCategory(item.code)">
                      <input type="checkbox" name="resource|parent" :id="item.code" :value="item.code" v-model="categories"/>
                      <span>{{item.title}}</span>&nbsp;<sup>{{getCountCategory(item.code)}}</sup>
                    </label>
                  </template>
                </label>
              </template>
            </div>
          </fieldset>
          <fieldset id="mse2_ms|availability">
            <h4 class="filter_title">Наличие</h4>
            <label class="" v-for="(item, i) in quantityForm" :key="i" style="display: block;">
              <input type="radio" name="ms|availability" :value="i" v-model="quantity"/>
              <span>{{item}}</span>&nbsp;<sup></sup>
            </label>
          </fieldset>

          <fieldset id="mse2_resource|publishedon">
            <h4 class="filter_title">Дата поступления</h4>
            <div class="d-flex">
              <date-picker
                      ref="picker1"
                      opens="right"
                      v-model="startDate"
                      value-type="timestamp"
                      style="width: 100%;"
                      placeholder="От"
              >
              </date-picker>
              <div style="width: 10px; flex: 0 0 10px;"></div>
              <date-picker
                      ref="picker2"
                      opens="right"
                      v-model="endDate"
                      value-type="timestamp"
                      style="width: 100%;"
                      placeholder="До"
              >
              </date-picker>
            </div>
          </fieldset>
          <fieldset id="mse2_msoption|manufacturer">
            <h4 class="filter_title">Производитель</h4>
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="Поиск" aria-label="Поиск" aria-describedby="basic-addon2" v-model="vendorFilter">
              <div class="input-group-append" @click="vendorFilter = ''" style="cursor: pointer;">
                <span class="input-group-text" id="basic-addon2">X</span>
              </div>
            </div>
            <div style="max-height: 250px; overflow-y:auto;">
              <template v-for="(vendor, i) in vendorsList">
                <label :for="'mse2_msoption|manufacturer_' + i" class="" :key="i" style="display: block; padding-top: 1px;">
                  <input type="checkbox" name="msoption|manufacturer" :id="'mse2_msoption|manufacturer_' + i" :value="vendor.name" v-model="vendors" />
                  <span>{{vendor.name}}</span>&nbsp;<sup>{{vendor.count}}</sup> </label>
              </template>
            </div>
          </fieldset>
        </div>
        <div class="d-flex">
          <button type="reset" class="btn btn-outline" style="margin-right:5px;" @click="clear">Сбросить</button>
          <button type="button" class="btn btn-outline-inverse" @click="filterHandler">Показать</button>
        </div>
      </form>
      <br /><br />
      <div class="form-group">
        <label for="mse2_limit">Показывать на странице</label>
        <select name="mse_limit" id="mse2_limit" class="form-control" v-model="perPage" @change="unlock = true">
          <option :value="v" selected="" v-for="(v, i) in [15, 30, 45]" :key="i">{{v}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-9">
      <h5>
        Всего результатов <span v-if="queryString">по запросу <em>«{{queryString.replace(/\++/g, ' ')}}»</em></span> : <span id="mse2_total">{{ total }}</span>
      </h5>
      <div class="row">
        <div id="mse2_sort" class="col-md-12">
          Сортировка:
          <a href="#" class="sort" :data-dir="currentSort.split('|')[1]" :class="{'active': currentSort && el.slug === currentSort.split('|')[0]}" v-for="(el, i) in sort" :key="i" @click.prevent="sortBy(el.slug)">{{el.title}}<span></span></a>
        </div>
      </div>
      <div class="row" v-if="total === 0 && !loading" style="margin-top: 4rem;">
        <div class="col-md-12">
          <h5>Ничего не найдено</h5>
        </div>
      </div>
      <div id="mse2_selected_wrapper">
        <!-- <div id="mse2_selected">Вы выбрали: <span></span></div> -->
      </div>
      <div id="mse2_results" style="padding-top: 2rem;">
        <Card v-for="item in items" :key="item.article" :item="item" />
      </div>
      <div class="mse2_pagination" v-show="total">
          <paginate
            :page-count="rows"
            :click-handler="pageChange"
            v-model="currentPage"
            :first-last-button="true"
            first-button-text="Первая"
            last-button-text="Последняя"
            prev-text="Пред."
            next-text="След."
            prev-class="page-item"
            next-class="page-item"
            page-class="page-item"
            prev-link-class="page-link"
            next-link-class="page-link"
            page-link-class="page-link"
            :container-class="'pagination'">
          </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueSlider from 'vue-slider-component'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/ru'
import Card from './card'

export default {
  name: 'AppLayout',
  components: {
    Card,
    VueSlider,
    DatePicker
  },
  data () {
    return {
      url: '/test',
      loading: false,
      items: [],
      http: axios,
      currentPage: 1,
      currentSort: '',
      perPage: 15,
      rows: null,
      total: 0,
      sort: [
        {
          title: 'Наличие',
          slug: 'quantity'
        },
        {
          title: 'Название',
          slug: 'pagetitle'
        },
        {
          title: 'Цена',
          slug: 'price'
        },
        {
          title: 'Популярность',
          slug: 'popular'
        },
        {
          title: 'Дата поступления',
          slug: 'created'
        }
      ],
      params: {
        alias: null
      },
      unlock: false,
      date: [],
      dateSource: '',
      startDate: '',
      endDate: '',
      vendors: [],
      vendorFilter: '',
      categories: [],
      countCat: [],
      quantity: 0,
      quantityForm: ['Все', 'В наличии', 'Нет в наличии'],
      price: [0, 0],
      maxPrice: 0,
      filters: {
        vendors: null,
        date: null,
        categories: null,
        quantity: null,
        price: null
      },
      filtersData: {
        categories: []
      },
      locale: {
        firstDay: 1,
        format: 'shortDate',
        monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        applyLabel: 'OK',
        cancelLabel: 'Отмена'
      },
      count: 1,
      queryString: null
    }
  },
  computed: {
    vendorsList: function () {
      var filter = this.vendorFilter.trim().toLowerCase()
      if ('vendors' in this.filtersData) {
        return this.filtersData.vendors.filter(el => {
          return el.name.toLowerCase().indexOf(filter) >= 0
        })
      } else {
        return this.filtersData.vendors
      }
    }
  },
  beforeMount () {
    const getParams = decodeURI(window.location.search.substring(1))
    const arr = getParams.split('&')
    arr.forEach(el => {
      if (el.length) {
        const item = el.split('=')
        this.params[item[0]] = item[1]
      }
    })
    if ('page' in this.params && this.params.page !== 1) {
      this.currentPage = this.params.page
    }
    if ('sort' in this.params) {
      this.currentSort = this.params.sort
    }
    if ('vendors' in this.params) {
      this.vendors = [...this.params.vendors.split(',')]
    }
    if ('categories' in this.params) {
      this.categories = [...this.params.categories.split(',')]
    }
    if ('price' in this.params) {
      this.price = [...this.params.price.split(',')]
    }
    if ('date' in this.params) {
      const dates = this.params.date.split(',')
      // const start = new Date(parseInt(dates[0]) * 1000)
      // const end = new Date(parseInt(dates[1]) * 1000)
      // this.startDate = { startDate: start.toJSON(), endDate: start.toJSON() }
      // this.endDate = { startDate: end.toJSON(), endDate: end.toJSON() }
      this.startDate = parseInt(dates[0]) * 1000
      this.endDate = parseInt(dates[1]) * 1000
    }
    const getPathname = window.location.pathname
    const gpmArr = getPathname.split('/').filter(el => el)
    this.params.alias = gpmArr[gpmArr.length - 1]
    this.loadData()
  },
  watch: {
    currentPage: function (value, old) {
      this.params.page = value
      if (this.unlock) {
        this.loadData()
      }
    },
    currentSort: function (value) {
      this.params.sort = value
      if (this.unlock) {
        this.loadData()
      }
    },
    perPage: function (value) {
      if (value !== 15) {
        this.params.per_page = value
      } else {
        if ('per_page' in this.params) {
          delete this.params.per_page
        }
      }
      if (this.unlock) {
        this.loadData()
      }
    },
    // dateSource: function (value) {
    //   if (value) {
    //     this.date = [value.startDate.getTime() / 1000, value.endDate.getTime() / 1000]
    //   }
    // },
    startDate: function (value) {
      if (value) {
        this.date[0] = value / 1000
      }
      if (this.date[1] === undefined) {
        var date = new Date()
        this.date[1] = parseInt(date.getTime() / 1000)
      }
    },
    endDate: function (value) {
      if (value) {
        this.date[1] = value / 1000
      }
      if (this.date[0] === undefined) {
        this.date[0] = 0
      }
    }
  },
  methods: {
    loadData (page) {
      this.loading = true
      this.http
        .get(this.url, {
          params: this.params
        })
        .then(data => {
          if ('items' in data.data && data.data.items.length) {
            this.items = Object.assign({}, data.data.items)
            this.total = data.data.total
            this.queryString = data.data.query_string
            this.rows = Math.ceil(data.data.total / this.perPage)
            this.filtersData = data.data.filters
            this.maxPrice = this.filtersData.max_price
            if (!('price' in this.params)) {
              this.price = [0, this.filtersData.max_price]
            }
          } else {
            this.total = 0
            this.items = []
            this.rows = null
          }
          this.setUrl()
          this.loading = false
          this.prepareCategories()
        })
    },
    pageChange (page) {
      this.unlock = true
      this.params.page = page
      this.currentPage = page
    },
    sortBy (slug) {
      this.pageChange(1)
      this.unlock = true
      if (!this.currentSort) {
        this.currentSort = slug + '|asc'
      } else {
        const arr = this.currentSort.split('|')
        if (arr[0] === slug) {
          switch (arr[1]) {
            case 'asc':
              this.currentSort = slug + '|desc'
              break
            case 'desc':
              this.currentSort = slug + '|asc'
              break
            default:
              this.currentSort = ''
              break
          }
        } else {
          this.currentSort = slug + '|asc'
        }
      }
    },
    setUrl () {
      let url = window.location.pathname
      let i = 0
      for (const el in this.params) {
        if (el === 'alias') { continue }
        if (i) { url += '&' } else { url += '?' }
        url += el + '=' + this.params[el]
        i++
      }
      window.history.pushState(this.params, '', url)
    },
    filterHandler () {
      this.unlock = true
      this.currentPage = 1
      this.params.page = 1
      for (const key in this.filters) {
        if (Array.isArray(this[key]) && this[key].length) {
          this.params[key] = this[key].join(',')
          if (key === 'price' && !this.price[0] && this.price[1] === this.maxPrice) {
            delete this.params[key]
          }
        } else if (typeof (this[key]) === 'number' && this[key]) {
          this.params[key] = this[key]
        } else {
          if (key in this.params) {
            delete this.params[key]
          }
        }
      }
      this.loadData()
    },
    clear () {
      this.date = []
      this.dateSource = ''
      this.startDate = ''
      this.endDate = ''
      this.vendors = []
      this.categories = []
      this.quantity = 0
      this.price = [0, this.maxPrice]
      this.filterHandler()
    },
    input (e) {
      console.log('e', e)
    },
    dateFormat (classes, date) {
      console.log('-->', classes, date)
    },
    numberValidator (e) {
      if (this.maxPrice < e.srcElement.valueAsNumber) {
        const nameArr = e.srcElement.name.split('_')
        this.price[nameArr[1]] = this.maxPrice
      }
    },
    getCountCategory (code) {
      let count = 0
      let countObj = this.filtersData.count_cat.find(el => el.category === code)
      countObj = countObj || { category: code, count: 0 }
      if (!code.includes('_')) {
        const re = new RegExp(code + '_', 'g')
        this.filtersData.count_cat.forEach(el => {
          if (el.category.search(re) !== -1) {
            count += parseInt(el.count)
          }
        })
      }
      if (countObj) {
        return count + parseInt(countObj ? countObj.count : 0)
      } else {
        return null
      }
    },
    prepareCategories () {
      if ('category_id' in this.filtersData && this.filtersData.category_id) {
        const categories = [...this.filtersData.categories]
        const roots = categories.filter(el => parseInt(el.parent) === this.filtersData.category_id)
        if (roots && roots.length) {
          roots.forEach(el => {
            el.items = categories.filter(e => e.parent === el.id)
          })
        }
        return roots
      } else {
        return [...this.filtersData.categories]
      }
    },
    checkCategory (e) {
      const re = new RegExp(e.target.value + '_', 'g')
      if (e.target.checked) {
        const innerCategories = this.filtersData.categories.filter(el => el.code.search(re) !== -1).map(el => el.code)
        this.categories = this.categories.concat(innerCategories)
      } else {
        this.categories = this.categories.filter(el => el.search(re) === -1)
      }
    }
  }
}
</script>
<style>

</style>
